// extracted by mini-css-extract-plugin
module.exports = {"attention":"gICab","blue":"RJGyF","dot":"nI4v9","red":"qyQsw","green":"r-AY3","orange":"a2FxP","yellow":"QDWXP","black":"_29lG+","blink":"RCE-u","blinker":"kOY3B"};